import React from "react";
import GlutMain from "../assets/images/Glut1/glut1.jpeg";
import Image0 from "../assets/images/Glut1/Image0.png";
import Image1 from "../assets/images/Glut1/Image1.jpg";
import Image2 from "../assets/images/Glut1/Image2.jpg";
import Image3 from "../assets/images/Glut1/Image3.jpg";
import Image4 from "../assets/images/Glut1/Image4.jpg";
import Image5 from "../assets/images/Glut1/Image5.JPG";
import Image6 from "../assets/images/Glut1/Image6.JPG";
import Image7 from "../assets/images/Glut1/Image7.JPG";
import Image8 from "../assets/images/Glut1/Image8.JPG";
import Image9 from "../assets/images/Glut1/Image9.JPG";

const galleryImages = [Image0, Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9];

export default function Glut1Info() {
  return (
    <section className="pt-12 px-6 pb-16 bg-gradient-to-br from-yellow-100 to-yellow-200 text-gray-800 max-w-6xl mx-auto rounded-xl shadow-lg mb-12 transition-all duration-500">
      <h2 className="text-3xl font-bold text-yellow-700 mb-8 text-center md:text-left">
        About GLUT‑1 Deficiency
      </h2>

      <div className="flex flex-col md:flex-row md:items-start md:space-x-8">
        {/* Image */}
        <img
          src={GlutMain}
          alt="Brain illustration representing GLUT1 deficiency"
          className="w-full md:w-1/3 rounded-lg shadow-md mb-6 md:mb-0 transform transition-transform duration-500 hover:scale-105 hover:shadow-xl"
          loading="lazy"
        />

        {/* Text */}
        <div className="md:w-2/3 text-gray-800">
          <p className="mb-4">
            GLUT‑1 Deficiency (Glucose Transporter Type 1 Deficiency Syndrome) is a rare genetic disorder that affects the brain’s energy supply. 
            (<a href="https://www.g1dfoundation.org/what-is-glut1-deficiency/" className="text-yellow-700 underline" target="_blank" rel="noopener noreferrer">source</a>)
          </p>
          <p className="mb-4">
            Because the GLUT1 protein doesn’t function properly, glucose (sugar) can’t efficiently cross the blood-brain barrier. This can lead to seizures, developmental delays, movement problems, and fatigue.
          </p>
          <p className="mb-4">
            The main treatment is a medically supervised <strong>ketogenic diet</strong>, which provides ketones as an alternative energy source for the brain.
          </p>
          <p className="text-sm text-gray-600">
            The GLUT1 Deficiency Foundation works to support families, fund research, and increase awareness of this condition. 
            (<a href="https://www.g1dfoundation.org/about-the-foundation/" className="text-yellow-700 underline" target="_blank" rel="noopener noreferrer">learn more</a>)
          </p>
        </div>
      </div>

       {/* Small Gallery */}
      <div className="mt-12">
        <h3 className="text-2xl font-semibold text-yellow-700 mb-6 text-center md:text-left">
          Million Dollar Bike Ride and Team Glut1
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-xl shadow-md bg-white"
            >
              <img
                src={img}
                loading="lazy"
                alt={`GLUT1 life moment ${index + 1}`}
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
